export const increment = (x: number) => x + 1;